// extracted by mini-css-extract-plugin
module.exports = {"container":"mapping_container__3rKAo","searchWrapper":"mapping_searchWrapper__2XYMO page_searchWrapper__1hpSp"};